import { render } from "./UserSelectionComponent.vue?vue&type=template&id=c51b12b4"
import script from "./UserSelectionComponent.vue?vue&type=script&lang=js"
export * from "./UserSelectionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__